import { locationMatches } from 'Shared/frontend/widgets/locationMatches';
import { PathElement, IStyleDetails } from 'Shared/frontend/widgets/StylesProvider';
import { IStylesRule } from 'Shared/frontend/themes/standardStyles';


export function applicableStyles(nodePath:PathElement[],styleDetails:IStyleDetails[]): IStylesRule
{
	let settings = {};
	let css = {};

	for (const details of styleDetails) {
		try {
			for (const rule of details.rules) {
				const ruleLocExpr = [...details.pathWhenAdded, ...rule.location];

				/* NOTE locExpr and stylePath both use the full paths of the component */
					if (locationMatches(ruleLocExpr,nodePath)) {
					css = {...css,...rule.css};
					settings = {...settings,...rule.settings}
				}
			}
		}
		catch(err) {
			console.warn(`Bad style: ${details.tag}: `+err);
		}
	}
	delete settings.location;

	return {...settings,css};
}

